"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var file_saver_1 = __importDefault(require("file-saver"));
var react_i18next_1 = require("react-i18next");
var Sentry = __importStar(require("@sentry/react"));
var __1 = require("../..");
var dg_super_app_bridge_1 = require("../../../../../shared/dg-super-app-bridge");
var image_format_1 = __importDefault(require("../../../../../../shared/util/image-format"));
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var requests_1 = require("../../../../../app/util/requests");
var ga_1 = require("../../../../../app/util/ga");
var DropdownButton_1 = require("../../../../widgets/DropdownButton");
var blobToBase64_1 = __importDefault(require("../../../../helpers/blobToBase64"));
var isDgSuperApp_1 = __importDefault(require("../../../../../app/util/isDgSuperApp"));
// Gets file extension from content-type.
function getFileExtension(format) {
    switch (format) {
        case image_format_1.default.SVG:
            return 'svg';
        case image_format_1.default.PNG:
            return 'png';
        case image_format_1.default.JPEG:
            return 'jpeg';
        default:
            throw Error('Invalid format passed to getFileExtension');
    }
}
// Downloads QR code from server.
function downloadServerQrCode(shortLink, format) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var url, endpoint, response, fileName, bodyBlob, blob, base64, fileType, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "https://" + document.location.host + "/" + shortLink;
                    endpoint = "/api/qrcode?url=" + encodeURIComponent(shortLink) + "&format=" + encodeURIComponent(format);
                    return [4 /*yield*/, requests_1.get(endpoint)];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 10];
                    // Google Analytics: QR Code generation - actions are stringed by shortlink and format
                    ga_1.GAEvent('qr code generation', format.toString(), 'successful');
                    fileName = (_a = response.headers.get('Filename')) !== null && _a !== void 0 ? _a : url;
                    return [4 /*yield*/, response.blob()];
                case 2:
                    bodyBlob = _b.sent();
                    blob = new Blob([bodyBlob], {
                        type: response.headers.get('content-type') || format,
                    });
                    if (!isDgSuperApp_1.default()) return [3 /*break*/, 8];
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 6, , 7]);
                    return [4 /*yield*/, blobToBase64_1.default(blob)];
                case 4:
                    base64 = _b.sent();
                    fileType = format === image_format_1.default.SVG ? 'anyFile' : 'image';
                    return [4 /*yield*/, dg_super_app_bridge_1.saveResource(fileName, base64, fileType, getFileExtension(format))];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    file_saver_1.default.saveAs(blob, fileName + "." + getFileExtension(format));
                    _b.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    // Sentry analytics: qr code download fail
                    Sentry.captureMessage("generate qr code for " + format + " unsuccessful");
                    ga_1.GAEvent('qr code generation', format.toString(), 'unsuccesful');
                    _b.label = 11;
                case 11: return [2 /*return*/];
            }
        });
    });
}
function DownloadButton() {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var modalState = __1.useDrawerState();
    var shortLink = modalState.relevantShortLink;
    var options = [
        {
            name: 'PNG',
            onClick: function () {
                downloadServerQrCode(shortLink, image_format_1.default.PNG);
            },
        },
        {
            name: 'SVG',
            onClick: function () {
                downloadServerQrCode(shortLink, image_format_1.default.SVG);
            },
        },
    ];
    return (react_1.default.createElement(ConfigOption_1.default, { title: t('editLink.downloadQr'), mobile: true, trailing: react_1.default.createElement(DropdownButton_1.DropdownButton, { buttonText: t('button.download'), options: options }), trailingPosition: ConfigOption_1.TrailingPosition.end }));
}
exports.default = DownloadButton;
